exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pt[data-v-5e96c3b9] {\n  padding-top: 18px !important;\n}\n", ""]);

// exports
